import { FC } from 'react';

import { RadioLabel } from '@gem/ui-kit';

import styles from './ChatAutoCleanupSettingsItem.styles.m.css';

interface IChatAutoCleanupSettingsItemProps {
  value: number;
  title: string;
  onChange: (value: number) => void;
  isActive: boolean;
  className?: string;
}

const CHAT_AUTO_CLEANUP_SETTINGS_ITEM_NAME = 'chat-auto-cleanup-settings-item';

export const ChatAutoCleanupSettingsItem: FC<IChatAutoCleanupSettingsItemProps> = (props) => {
  const { onChange, value, title, isActive } = props;

  return (
    <RadioLabel
      isActive={isActive}
      name={CHAT_AUTO_CLEANUP_SETTINGS_ITEM_NAME}
      onChange={(): void => onChange(value)}
      title={title}
      titleClassName={styles.title}
      value={value}
    />
  );
};
